import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { submitFetchBenchmarkingRequest } from "../../../../store/features/actions/fetchBenchmarkingActions";
import useActiveScrollSection from "../../../../hooks/useActiveScrollSection";
import ExecutiveOverview from "./ExecutiveOverview";
import MarketPosition from "./MarketPosition";
import CustomerIntelligence from "./CustomerIntelligence";
import {
  ChevronLeft,
  ChevronRight,
  Eye,
  Target,
  Heart,
  Shield,
  Zap,
  Box,
  Globe,
  Users,
  Search,
} from "react-feather";
import * as FeatherIcon from "react-feather";
import DetailModal from "./DetailModal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MarketPositionNew.css";
import {
  getAllSubdimensionMatches,
  getAllSubdimensionMatchesNewBenchmarking,
} from "../../../../services/commonService";
const MarketPositionNew = ({ activeSubKey, setActiveSubKey }) => {
  const dispatch = useDispatch();
  const { clientName } = useParams();
  const [currentSection, setCurrentSection] = useState(1);
  const [completedSections, setCompletedSections] = useState([]);

  const [executiveOverview, setExecutiveOverview] = useState([]);
  const [marketPosition, setMarketPosition] = useState([]);
  const [customerIntelligence, setCustomerIntelligence] = useState([]);

  // START => MP NEW TABS EXECUTIVE OVERVIEW++++++++++++++++++++++++++++++++
  const [selectedCompanyBreakdown, setSelectedCompanyBreakdown] =
    useState(null);

  const [executiveSummary, setExecutiveSummary] = useState([]);
  const [scoreBreakdown, setScoreBreakdown] = useState([]);
  const [threatAssessment, setThreatAssesment] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [howWeCompare, setHowWeCompare] = useState([]);
  const [strategicPriorities, setStrategicPriorities] = useState([]);
  // Helper function to parse markdown-style links and convert to JSX
  const parseLinks = (text) => {
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      const linkText = match[1];
      const url = match[2];
      parts.push(
        <a
          key={match.index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#0d6efd", textDecoration: "none" }}
          onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
          onMouseOut={(e) => (e.target.style.textDecoration = "none")}
        >
          {linkText}
        </a>
      );
      lastIndex = linkRegex.lastIndex;
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts.length > 0 ? parts : text;
  };

  // Helper: render bold + linked text pairs used in bullet points & action items
  const renderBoldText = (boldText, text) => (
    <>
      <strong>{boldText}: </strong>
      {parseLinks(text)}
    </>
  );

  // Helper: render the correct icon per strategic priority
  const renderPriorityIcon = (iconType) => {
    if (iconType === "Target")
      return <Target className="text-primary1 flex-shrink-0" size={16} />;
    if (iconType === "Shield")
      return <Shield className="text-danger1 flex-shrink-0" size={16} />;
    // "checkbox" fallback
    return (
      <div
        className="border border-warning1 rounded flex-shrink-0"
        style={{ width: "1rem", height: "1rem" }}
      />
    );
  };
  // END => MP NEW TABS EXECUTIVE OVERVIEW++++++++++++++++++++++++++++++++

  // START => MP NEW TABS MARKET POSITION++++++++++++++++++++++++++++++++
  const [selectedDetailModal, setSelectedDetailModal] = useState(null);
  const [heatMapData, setHeatmapData] = useState([]);
  const [heatMapLegend, setHeatmapLegend] = useState([]);
  const [heatMapInsight, setHeatmapInsight] = useState([]);
  const [companiesMp, setCompaniesMp] = useState([]);
  const [focusAreas, setFocusAreas] = useState([]);
  const [detailedCompetitiveData, setDetailedCompetitiveData] = useState([]);

  const heatMapCols = [
    { label: "Technologies", icon: <Zap size={16} />, key: "technologies" },
    { label: "Applications", icon: <Box size={16} />, key: "applications" },
    { label: "Geographies", icon: <Globe size={16} />, key: "geographies" },
    { label: "Customer Segments", icon: <Users size={16} />, key: "segments" },
  ];

  const focusCols = [
    {
      label: "Top Technologies",
      icon: <Zap size={14} />,
      key: "technologies",
      color: "bg-purple",
    },
    {
      label: "Top Applications",
      icon: <Box size={14} />,
      key: "applications",
      color: "bg-primary",
    },
    {
      label: "Top Geographies",
      icon: <Globe size={14} />,
      key: "geographies",
      color: "bg-success",
    },
    {
      label: "Top Segments",
      icon: <Users size={14} />,
      key: "segments",
      color: "bg-warning",
    },
    {
      label: "Key Use Cases",
      icon: <Target size={14} />,
      key: "useCases",
      color: "bg-danger",
    },
  ];

  const renderHeatMapItems = (items) =>
    items.map((item, idx) => (
      <div key={idx} className="mb-3">
        <div
          className={`heatmap-item bg-${item.color} bg-opacity-10 border-start border-${item.color} border-4 p-2 rounded d-flex justify-content-between align-items-center`}
        >
          <div>
            <div
              className="comp_head_new"
              style={{ fontSize: "12px", fontWeight: 600, color: "#2d343d" }}
            >
              {item.name}
            </div>
            <div className="text-muted" style={{ fontSize: "11px" }}>
              {item.players} players • {item.marketSize}
            </div>
          </div>
          <button
            onClick={() => setSelectedDetailModal(item.dataKey)}
            className="btn btn-sm btn-link p-0 ms-2"
          >
            <Search size={18} className="text-primary" />
          </button>
        </div>
      </div>
    ));
  // END => MP NEW TABS MARKET POSITION++++++++++++++++++++++++++++++++

  // START => MP NEW TABS CUSTOMER INTELLIGENCE++++++++++++++++++++++++++++++++
  const [selectedHeatMapItem, setSelectedHeatMapItem] = useState(null);
  const [selectedDetailModalCi, setSelectedDetailModalCi] = useState(null);
  const [customerSegmentHeatMap, setCustomerSegmentHeatMap] = useState([]);
  const [legendItems, setLegendItems] = useState([]);
  const [battleMapInsight, setBattleMapInsight] = useState([]);
  const [customerIntelligenceCi, setCustomerIntelligenceCi] = useState([]);
  const [companiesCi, setCompaniesCi] = useState([]);
  const [detailedCompetitiveDataCi, setDetailedCompetitiveDataCi] = useState(
    []
  );

  const renderInsight = (text) => {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, i) =>
      part.startsWith("**") && part.endsWith("**") ? (
        <strong key={i}>{part.replace(/\*\*/g, "")}</strong>
      ) : (
        part
      )
    );
  };
  // END => MP NEW TABS MARKET INTELLIGENCE++++++++++++++++++++++++++++++++

  const { loading, data, error } = useSelector(
    (state) => state.fetchBenchmarkingReducer
  );
  const executiveOverviewMpNewRef = useRef(null);
  const executiveSummaryRef = useRef(null);
  const threatAssesmentRef = useRef(null);
  const howWeCompareRef = useRef(null);
  const strategicPrioritiesRef = useRef(null);
  const competitionHeatmapRef = useRef(null);

  const marketPositionNewRef = useRef(null);
  const companyFocusesRef = useRef(null);

  // const customerIntelligenceRef = useRef(null);
  const customerSegmentHeatmapRef = useRef(null);
  const keyStrengthsRef = useRef(null);
  const programmaticScrollRef = useRef(false);

  const sectionMap = {
    // executiveOverviewMpNewTab: executiveOverviewMpNewRef,
    executiveSummaryTab: executiveSummaryRef,
    threatAssesmentTab: threatAssesmentRef,
    howWeCompareTab: howWeCompareRef,
    strategicPrioritiesTab: strategicPrioritiesRef,
    // marketPositionNewTab: marketPositionNewRef,
    competitionHeatmapTab: competitionHeatmapRef,
    companyFocusesTab: companyFocusesRef,
    // customerIntelligenceTab: customerIntelligenceRef,
    customerSegmentHeatmapTab: customerSegmentHeatmapRef,
    keyStrengthsTab: keyStrengthsRef,
  };

  const { showScrollTop, scrollToTop } = useActiveScrollSection(
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    data
  );

  const scrollToSection = (key) => {
    const sectionRef = sectionMap[key];

    if (sectionRef?.current) {
      programmaticScrollRef.current = true;

      sectionRef.current.scrollIntoView({
        behavior: "instant",
        block: "start",
      });

      setTimeout(() => {
        programmaticScrollRef.current = false;
      }, 700);
    }
  };

  useEffect(() => {
    dispatch(
      submitFetchBenchmarkingRequest(
        clientName,
        "Market Position & Intelligence"
      )
    );
  }, []);

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   if (!activeSubKey) return;

  //   const sectionRef = sectionMap[activeSubKey];
  //   if (sectionRef?.current) {
  //     // mark as programmatic scroll so scroll-spy ignores this movement
  //     programmaticScrollRef.current = true;

  //     const yOffset = -100;
  //     const y =
  //       sectionRef.current.getBoundingClientRect().top +
  //       window.scrollY +
  //       yOffset;

  //     window.scrollTo({ top: y, behavior: "instant" });

  //     // clear the flag after animation; tune timeout to match your animation time
  //     const t = setTimeout(() => {
  //       programmaticScrollRef.current = false;
  //     }, 700);

  //     return () => clearTimeout(t);
  //   }
  // }, [activeSubKey]);

  useEffect(() => {
    if (!activeSubKey) return;

    scrollToSection(activeSubKey);
  }, [activeSubKey]);

  // +++++++++++++++++++++++++++++++++++++++++++++
  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL

  // useEffect(() => {
  //   let scrollTimeout = null;
  //   let ticking = false;

  //   const handleScroll = () => {
  //     if (programmaticScrollRef.current) return; // ignore programmatic scrolls
  //     if (ticking) return;
  //     ticking = true;

  //     window.requestAnimationFrame(() => {
  //       // Clear previous timeout (debounce)
  //       if (scrollTimeout) clearTimeout(scrollTimeout);

  //       // Wait until user stops scrolling for 200ms
  //       scrollTimeout = setTimeout(() => {
  //         const scrollPosition = window.scrollY + 120; // offset for header, etc.
  //         let currentKey = null;

  //         Object.entries(sectionMap).forEach(([key, ref]) => {
  //           if (!ref.current) return;
  //           const sectionTop = ref.current.offsetTop;
  //           const sectionHeight = ref.current.offsetHeight;

  //           // Check if scroll is within this section
  //           if (
  //             scrollPosition >= sectionTop &&
  //             scrollPosition < sectionTop + sectionHeight
  //           ) {
  //             currentKey = key;
  //           }
  //         });

  //         // update nav only if different
  //         if (currentKey && currentKey !== activeSubKey) {
  //           setActiveSubKey(currentKey);
  //         }
  //       }, 200); // change nav only after 200ms of no scrolling

  //       ticking = false;
  //     });
  //   };

  //   window.addEventListener("scroll", handleScroll, { passive: true });

  //   // run once on mount
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //     if (scrollTimeout) clearTimeout(scrollTimeout);
  //   };
  // }, [activeSubKey, setActiveSubKey]);

  // USEEFFECT FOR UPDATING LEFT NAVIGATION LINK ON SCROLL
  // +++++++++++++++++++++++++++++++++++++++++++++

  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // useEffect(() => {
  //   // console.log(
  //   //   "Benchmarking data for Market Position & Intelligence: " +
  //   //     JSON.stringify(data)
  //   // );

  //   const tempExecutiveOverview = getAllSubdimensionMatchesNewBenchmarking(
  //     data,
  //     "Executive Overview Data"
  //   );
  //   setExecutiveOverview(tempExecutiveOverview);

  //   const tempMarketPosition = getAllSubdimensionMatchesNewBenchmarking(
  //     data,
  //     "Market Position Data"
  //   );
  //   setMarketPosition(tempMarketPosition);

  //   const tempCustomerIntelligencce = getAllSubdimensionMatchesNewBenchmarking(
  //     data,
  //     "Customer Intelligence Data"
  //   );
  //   setCustomerIntelligence(tempCustomerIntelligencce);

  //   // console.log(
  //   //   "Executive Overview - benchmarking data: " +
  //   //     JSON.stringify(tempExecutiveOverview)
  //   // );
  //   // console.log(
  //   //   "Market Position - benchmarking data: " +
  //   //     JSON.stringify(tempMarketPosition)
  //   // );
  //   // console.log(
  //   //   "Customer Intelligence - benchmarking data: " +
  //   //     JSON.stringify(tempCustomerIntelligencce)
  //   // );
  // }, [data]);

  useEffect(() => {
    if (!data || data?.results.length === 0) return;
    try {
      const tempExecutiveOverview = getAllSubdimensionMatchesNewBenchmarking(
        data,
        "Executive Overview Data"
      );
      setExecutiveOverview(
        getAllSubdimensionMatchesNewBenchmarking(
          data,
          "Executive Overview Data"
        )
      );

      // START => New tabs data +++++++++++++++++++++++++++++++++++++++++
      // Executive Overview
      setExecutiveSummary(
        tempExecutiveOverview?.[0]?.response?.executiveSummary
      );
      setThreatAssesment(
        tempExecutiveOverview?.[0]?.response?.threatAssessment
      );
      setHowWeCompare(tempExecutiveOverview?.[0]?.response?.howWeCompare);
      setScoreBreakdown(tempExecutiveOverview?.[0]?.response?.scoreBreakdown);
      setCompanies(tempExecutiveOverview?.[0]?.response?.companies);
      setStrategicPriorities(
        tempExecutiveOverview?.[0]?.response?.strategicPriorities
      );

      // Market Position
      const tempMarketPosition = getAllSubdimensionMatchesNewBenchmarking(
        data,
        "Market Position Data"
      );

      setHeatmapData(tempMarketPosition?.[0]?.response?.heatMapData);
      setHeatmapLegend(tempMarketPosition?.[0]?.response?.heatMapLegend);
      setHeatmapInsight(tempMarketPosition?.[0]?.response?.heatMapInsight);
      setCompaniesMp(tempMarketPosition?.[0]?.response?.companies);
      setFocusAreas(tempMarketPosition?.[0]?.response?.focusAreas);
      setDetailedCompetitiveData(
        tempMarketPosition?.[0]?.response?.detailedCompetitiveData
      );

      //Customer Intelligence
      const tempCustomerIntelligence = getAllSubdimensionMatchesNewBenchmarking(
        data,
        "Customer Intelligence Data"
      );
      setCustomerSegmentHeatMap(
        tempCustomerIntelligence?.[0]?.response?.customerSegmentHeatMap
      );
      setLegendItems(tempCustomerIntelligence?.[0]?.response?.legendItems);
      setBattleMapInsight(
        tempCustomerIntelligence?.[0]?.response?.battleMapInsight
      );
      setCustomerIntelligenceCi(
        tempCustomerIntelligence?.[0]?.response?.customerIntelligence
      );
      setCompaniesCi(tempCustomerIntelligence?.[0]?.response?.companies);
      setDetailedCompetitiveDataCi(
        tempCustomerIntelligence?.[0]?.response?.detailedCompetitiveData
      );

      // END => New tabs data +++++++++++++++++++++++++++++++++++++++++

      setMarketPosition(
        getAllSubdimensionMatchesNewBenchmarking(data, "Market Position Data")
      );

      setCustomerIntelligence(
        getAllSubdimensionMatchesNewBenchmarking(
          data,
          "Customer Intelligence Data"
        )
      );
    } catch (err) {
      console.error("Failed to parse benchmarking data:", err);
    }
  }, [data]);
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    // Scroll to top when section changes
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const sections = [
    { id: 1, title: "Executive Overview", icon: Eye },
    { id: 2, title: "Market Position", icon: Target },
    { id: 3, title: "Customer Intelligence", icon: Heart },
  ];

  const handleNext = () => {
    if (!completedSections.includes(currentSection)) {
      setCompletedSections([...completedSections, currentSection]);
    }
    if (currentSection < 3) {
      setCurrentSection(currentSection + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrevious = () => {
    if (currentSection > 1) {
      setCurrentSection(currentSection - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleJumpToSection = (sectionId) => {
    setCurrentSection(sectionId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!loading && (!data || data?.results.length === 0))
    return (
      <div className="text-center py-5 text-danger">
        Data not available currently, please revisit after some time.
      </div>
    );

  return (
    <div className="min-vh-100 bg-light">
      <style>{`
        .section-btn {
          flex: 1;
          padding: 12px;
          border-radius: 0.5rem;
          transition: all 0.3s ease;
          border: 2px solid transparent;
          display:flex;
          align-item:center;
          text-align:center;
        }
        .section-btn-current {
          background: #0d6efd;
          color: #fff;
          box-shadow: 0 4px 6px rgba(13,110,253,0.3);
        }
        .section-btn-completed {
          background: #d1e7dd;
          color: #0f5132;
        }
        .section-btn-completed:hover {
          background: #a3cfbb;
        }
        .section-btn-pending {
          background: #e9ecef;
          color: #6c757d;
        }
        .section-btn-pending:hover {
          background: #dee2e6;
        }
        .nav-button {
          padding: 8px 10px 8px 10px;
          color: #fff !important;
          font-family: Inter;
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          border: none;
          min-width: 100px;
          border-radius: 8px;
        }
        .nav-button:disabled {
          background: #BABFCC;
          color: #adb5bd;
          cursor: not-allowed;
        }
        .nav-button-prev:not(:disabled) {
          background: #BABFCC;
          color: #fff;
        }
        .nav-button-prev:not(:disabled):hover {
          background: #343a40;
        }
        .nav-button-next:not(:disabled) {
          background: #4E6BCA;
          color: #fff;
        }
        .nav-button-next:not(:disabled):hover {
          background: #0b5ed7;
        }

        /* START => Executive overview page css +++++++++++++++++++++++++++++++++++++++++++++++++++++ */
        .close-button {
          background: #fff;
          border: none;
          border-radius: 0.375rem;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .executive-summary-card {
          border-bottom: 1px solid #e9ecef;
          background-color: #f7f9ff;
          padding: 12px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
          margin-bottom: 10px;
        }
        .exe_summary {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
        }
        .summary-icon-box {
          width: 3.5rem;
          height: 3.5rem;
          background: #fff;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .stat-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align: center;
        }
        .score_inter {
          font-weight: 400;
          font-size: 12px;
          background-color: #f0f4fa;
          line-height: 1.4;
          color: rgba(0, 0, 0, 0.6);
          margin-bottom: 20px;
          padding: 12px 8px 12px 12px;
          border-radius: 8px;
        }
        .stat-card-text {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 0.5rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .stat-card-value {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 0.25rem;
          line-height: 1;
          color: #000;
        }
        .stat-card-label {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
        }
        .bottom-line-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align: left;
        }
        .bottom-line-card p {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 0px;
        }
        .sub_para {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 0px;
        }
        .threat-card {
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .threat-card-high {
          background-color: #fef2f2;
          border: 1px solid #b91c1c29;
        }
        .number_danger,
        .badge_danger {
          background-color: #b91c1c !important;
          border-radius: 5px !important;
        }
        .list_li {
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
          align-items: start;
          display: flex;
        }
        .dot_list {
          margin-right: 5px;
        }
        .text-warning-med {
        }
        .score {
          font-size: 12px;
        }
        .threat-card-medium {
          background-color: #eff6ff;
          border: 1px solid #2563eb29;
        }
        .number_med,
        .number_badge_med {
          background-color: #1e74e6 !important;
          color: #fff !important;
        }
        .number_low,
        .number_badge_low {
          background-color: #15803d !important;
          color: #fff !important;
        }
        .threat-card-low {
          background-color: #f0fdf4;
          border: 1px solid #15803d29;
        }
        .score-bar-container {
          height: 13px;
          background: #e9ecef;
          border-radius: 8px;
          overflow: hidden;
          position: relative;
        }
        .score-bar {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 1rem;
          transition: all 0.5s ease;
          cursor: pointer;
          font-size: 12px;
        }
        .score-bar:hover {
          opacity: 0.9;
          transform: scaleY(1.05);
        }
        .company-card {
          margin-bottom: 1rem;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 10px 16px;
        }
        .company-card-highlight {
          background: #e7f3ff;
          border: 2px solid #0d6efd;
          box-shadow: 0 4px 10px rgba(13, 110, 253, 0.2);
        }
        .breakdown-card {
          background: linear-gradient(135deg, #e7f3ff 0%, #eef2ff 100%);
          border-radius: 0.75rem;
          padding: 1.5rem;
          border: 2px solid #0d6efd;
          box-shadow: 0 8px 20px rgba(13, 110, 253, 0.2);
          margin-top: 1rem;
          margin-bottom: 1rem;
        }
        .dimension-card {
          background: #fff;
          border-radius: 0.5rem;
          padding: 1rem;
          transition: all 0.3s ease;
        }
        .dimension-card:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
        .dimension-progress {
          height: 0.5rem;
          background: #e9ecef;
          border-radius: 1rem;
          overflow: hidden;
          position: relative;
        }
        .dimension-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #0d6efd 0%, #0b5ed7 100%);
          transition: width 0.5s ease;
        }
        .priority-card {
          position: relative;
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .priority-number {
          position: absolute;
          top: -0.75rem;
          left: -0.75rem;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
        .priority-defend {
          background-color: #fef2f2;
          border: 1px solid #b91c1c29;
        }
        .attack_number {
          background-color: #1e74e6 !important;
        }
        .defend_number {
          background-color: #b91c1c !important;
        }
        .avoid_number {
          background-color: #15803d !important;
        }
        .priority-attack {
          background-color: #eff6ff;
          border: 1px solid #2563eb29;
        }
        .priority-avoid {
          background-color: #f0fdf4;
          border: 1px solid #15803d29;
        }
        .main_head_strat {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
        }
        .main_subhead_strat {
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
        }
        .action-item {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
        }
        .company_name_item {
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
          color: #1e1c25;
        }
        /* END => Executive overview page css +++++++++++++++++++++++++++++++++++++++++++++++++++++ */

        /* START => Market position page css*/
        .bg-custom-danger-only { background-color: #b91c1c; width: 16px; height: 16px; border-radius: 2px; }
        .bg-custom-info-only { background-color: #1e74e6; width: 16px; height: 16px; border-radius: 2px; }
        .bg-custom-warning-only { background-color: #CFAB69; width: 16px; height: 16px; border-radius: 2px; }
        .bg-new_custom_warning { background-color: #CFAB69;}
        .bg-custom-success-only { background-color: #15803d; width: 16px; height: 16px; border-radius: 2px; }
        .score_inter { background-color: #f0f4fa; padding: 12px; border-radius: 8px; font-size: 12px; color: #475569; }
        .focus-badge { font-size: 11px; padding: 4px 8px; border-radius: 4px; background: #fff; border: 1px solid #cbd5e1; display: inline-block; margin: 2px; }
        .comp_map_block { padding: 16px; border: solid 1px #98a4aa33; border-radius: 8px; margin-bottom: 20px; }
        // .bg-purple { background-color: #6f42c1; }
        .bg-purple { background-color: #6f42c129; }
        .custom_highlight_table {
          border-color: inherit;
          background-color: #f0f4fa;
          --bs-table-bg: #f0f4fa;
      }
      /* END => Market position page css*/

      /* START => Customer Intelligence page css +++++++++++++++++++++++++++++++++++++++++++++++++++++ */  
      .segment-item { transition: all 0.3s ease; cursor: pointer; }
      .segment-item:hover { transform: scale(1.02); box-shadow: 0 4px 8px rgba(0,0,0,0.1); }
      .selected-segment { transform: scale(1.05); box-shadow: 0 6px 12px rgba(0,0,0,0.15); }
      .intelligence-card { border-radius: 8px; padding: 12px 16px; border: 1px solid; }
      .comp_map_block { border-bottom: 1px solid #e9ecef; background-color: #fff; padding: 12px 16px; border: solid 1px #98a4aa33; border-radius: 8px; }
      .comp_subhead { font-size:14px; font-weight:600 !Important; }
      .comp_head_new { color:#2d343d !important; font-size:13px; line-height:17.5px; font-weight:600; margin-bottom:5px; }
      .comp_subhead_new { color:#64748B !important; font-size:13px; line-height:17.5px; font-weight:400; margin-bottom:5px; }
      .comp_head_number { color:#363b4b !important; font-size:13px; line-height:17.5px; font-weight:600; }
      .bg-custom-danger { background-color: #fef2f2; border-left: 4px solid #b91c1c !important; }
      .bg-custom-danger-only { background-color: #b91c1c; }
      .bg-custom-info { background-color: #eff6ff; border-left: 4px solid #1e74e6 !important; }
      .bg-custom-info-only { background-color: #1e74e6; }
      .bg-custom-success { background-color: #f0fdf4; border-left: 4px solid #15803d !important; }
      .bg-custom-success-only { background-color: #15803d; }
      .bg-custom-warning-only { background-color: #CFAB69; }
      .bg-custom-warning { background-color: #feebc89c; border-left: 4px solid #CFAB69 !important; }
      .score_inter { font-weight: 400; font-size: 12px; background-color: #f0f4fa; line-height: 1.4; color: rgba(0, 0, 0, 0.6); margin-bottom: 20px; padding: 12px 8px 12px 12px; border-radius: 8px; }      
      /* END => Customer Intelligence page css +++++++++++++++++++++++++++++++++++++++++++++++++++++ */  

    `}</style>

      {/* Header - NOT STICKY */}
      <div className="bg-white shadow-sm border-bottom market_new_position_wrapper">
        <div className="container py-3 bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="main_head">
              Market Position & Customer Intelligence
            </h1>
            {/* <div className="section_number">
              Section {currentSection} of {sections.length}
            </div> */}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-4 bg-white">
        {/* {renderCurrentSection()} */}
        {/* <> */}
        {/* <div class="section-header">
          <h2 class="section-title">Executive Overview</h2>
          <div class="separator-line"></div>
        </div> */}
        {/* START => Executive Summary ─────────────────────────────────────────────── */}
        {Object.values(executiveSummary)?.length > 0 ? (
          <div ref={executiveSummaryRef}>
            <div className="executive-summary-card">
              <div className="d-flex align-items-start gap-2 mb-2">
                <div>
                  <h2 className="exe_summary ml-1">Executive Summary</h2>
                </div>
              </div>

              <div className="row g-3 mb-3">
                {executiveSummary?.stats?.map((stat, idx) => (
                  <div className="col-md-4" key={idx}>
                    <div className="stat-card d-flex flex-column">
                      <div className="stat-card-text">{stat.label}</div>
                      <div className="stat-card-value">{stat.value}</div>
                      <div className="stat-card-label">{stat.subLabel}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bottom-line-card">
                <p>{parseLinks(executiveSummary.bottomLine)}</p>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* END => Executive Summary ─────────────────────────────────────────────── */}
        {/* START => Threat Assessment ─────────────────────────────────────────────── */}
        {threatAssessment?.length > 0 ? (
          <div ref={threatAssesmentRef}>
            <div className="card border-0 mb-2">
              <div className="card-body">
                <h3 className="exe_summary">Threat Assessment</h3>
                <div className="row g-3">
                  {threatAssessment?.map((threat, idx) => (
                    <div className="col-md-4" key={idx}>
                      <div
                        className={`threat-card ${threat.threatClass} card_high_threat`}
                      >
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <div className="d-flex gap-2">
                            <div
                              className={`${threat.scoreBsClass} text-white rounded p-2 ${threat.scoreColorClass} fw-bold`}
                            >
                              {threat.score}
                            </div>
                            <div>
                              <div className="fw-bold font13">
                                {threat.name}
                              </div>
                              {/* <div className="text-muted score">
                          Score: {threat.score}/10
                        </div> */}
                            </div>
                          </div>
                          <span
                            className={`badge ${threat.badgeBsClass} ${threat.badgeColorClass} font11`}
                          >
                            {threat.threatLevel}
                          </span>
                        </div>
                        <div className="small">
                          {threat.bulletPoints.map((bp, bpIdx) => (
                            <div
                              className={`list_li ${
                                bpIdx < threat.bulletPoints.length - 1
                                  ? "mb-2"
                                  : ""
                              }`}
                              key={bpIdx}
                            >
                              <span className="fw-bold dot_list">• </span>
                              <span>
                                {renderBoldText(bp.boldText, bp.text)}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* END => Threat Assessment ─────────────────────────────────────────────── */}

        {/* START => How We Compare ────────────────────────────────────────────────── */}
        {Object.values(howWeCompare)?.length > 0 ? (
          <div ref={howWeCompareRef}>
            <div className="card border-0">
              <div className="card-body">
                <h3 className="exe_summary">How We Compare</h3>
                <p className="sub_para mb-2">
                  Scores reflect overall competitive strength based on scale,
                  capabilities, market position, and growth trajectory.
                </p>

                <div className="sub_para mb-4  justify-content-between align-items-center">
                  <div className="text-muted mb-3">
                    <strong>Note:</strong> {parseLinks(howWeCompare.noteText)}
                  </div>
                  <div className="d-flex gap-3">
                    {howWeCompare.legend.map((leg, idx) => (
                      <div
                        className="d-flex align-items-center gap-1"
                        key={idx}
                      >
                        <div
                          className={leg.colorClass}
                          style={{
                            width: "0.75rem",
                            height: "0.75rem",
                            borderRadius: "2px",
                          }}
                        />
                        <span className="text-muted">{leg.label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {companies.map((item, idx) => (
                  <div key={idx}>
                    <div
                      className={`company-card ${
                        item.isHighlighted ? "company-card-highlight" : ""
                      }`}
                    >
                      <div className="row align-items-center">
                        <div className="col-md-3">
                          <div className="fw-bold company_name_item">
                            {item.company}
                          </div>
                          <div className="small text-muted sub_para">
                            {item.status}
                          </div>
                        </div>
                        <div className="col-md-9">
                          <div className="score-bar-container">
                            <div
                              className={`score-bar ${item.colorClass}`}
                              style={{ width: item.width }}
                              onClick={() =>
                                setSelectedCompanyBreakdown(
                                  selectedCompanyBreakdown === item.companyId
                                    ? null
                                    : item.companyId
                                )
                              }
                              title="Click to see score breakdown"
                            >
                              <span className="text-white fw-bold fs-9">
                                {item.score}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="small text-muted fst-italic sub_para"
                        style={{ marginLeft: "26%", marginTop: "-10px" }}
                      >
                        {parseLinks(item.insight)}
                      </div>
                    </div>

                    {selectedCompanyBreakdown === item.companyId && (
                      <div className="breakdown-card">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="h6 fw-bold mb-0">
                            {item.company} Score Details
                          </h4>
                          <button
                            class="close-button"
                            onClick={() => setSelectedCompanyBreakdown(null)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#6610f2"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                          </button>
                        </div>

                        <div className="bg-white rounded p-3 mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="fw-bold">Overall Score</span>
                            <span className="font14 fw-bold text-primary">
                              {scoreBreakdown[item.companyId].overall}/10
                            </span>
                          </div>
                          <div className="small text-muted">
                            Calculated from 5 sub-dimensions below
                          </div>
                        </div>

                        <div className="row g-3">
                          {scoreBreakdown[item.companyId].dimensions.map(
                            (dim, dimIdx) => (
                              <div key={dimIdx} className="col-12">
                                <div className="dimension-card">
                                  <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div className="flex-grow-1">
                                      <div className="d-flex align-items-center gap-2 mb-2">
                                        <span className="fw-semibold">
                                          {dim.name}
                                        </span>
                                        <span className="badge bg-primary">
                                          {dim.score}/10
                                        </span>
                                      </div>
                                      <div className="dimension-progress">
                                        <div
                                          className="dimension-progress-bar"
                                          style={{
                                            width: `${dim.score * 10}%`,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <p className="small text-muted mb-0 mt-2">
                                    {parseLinks(dim.explanation)}
                                  </p>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                <div className="score_inter">
                  <strong>Score Interpretation:</strong>{" "}
                  {howWeCompare.scoreInterpretation}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* END => How We Compare ────────────────────────────────────────────────── */}

        {/* START => Strategic Priorities ──────────────────────────────────────────── */}
        {strategicPriorities?.length > 0 ? (
          <div ref={strategicPrioritiesRef}>
            <div className="card border-0 mb-4">
              <div className="card-body">
                <h3 className="exe_summary mb-3">Strategic Priorities</h3>
                <div className="row g-3">
                  {strategicPriorities.map((priority, idx) => (
                    <div className="col-md-4" key={idx}>
                      <div className={`priority-card ${priority.cardClass}`}>
                        <div
                          className={`priority-number priority-number-attack bg-primary text-white ${priority.numberClass}`}
                        >
                          {priority.number}
                        </div>
                        <h4
                          className="main_head_strat"
                          style={{ minHeight: "auto" }}
                        >
                          {priority.type}
                        </h4>
                        <div className="main_subhead_strat mb-3">
                          {priority.subHead}
                        </div>
                        <div className="small">
                          {priority.actionItems.map((item, itemIdx) => (
                            <div className="action-item" key={itemIdx}>
                              {renderPriorityIcon(priority.iconType)}
                              <div>
                                {renderBoldText(item.boldText, item.text)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        {/* START => Strategic Priorities ──────────────────────────────────────────── */}

        {/* <div ref={executiveOverviewMpNewRef}>
          <ExecutiveOverview executiveOverviewData={executiveOverview} />
        </div> */}

        {/* <div class="section-header">
          <h2 class="section-title">Market Position</h2>
          <div class="separator-line"></div>
        </div> */}

        <DetailModal
          selectedDetailModal={selectedDetailModal}
          setSelectedDetailModal={setSelectedDetailModal}
          fullData={detailedCompetitiveData}
        />

        {/* START => Competition Heat Map Section --- */}
        <div ref={competitionHeatmapRef}>
          {Object.values(heatMapData)?.length > 0 ? (
            <div className="comp_map_block">
              <h5 className="mb-4 fw-bold">Competition Heat Map</h5>
              <div className="row g-3">
                {heatMapCols.map((col) => (
                  <div className="col-md-3" key={col.key}>
                    <div className="d-flex align-items-center gap-2 mb-3 fw-bold small text-muted">
                      {col.icon} {col.label}
                    </div>
                    {renderHeatMapItems(heatMapData[col.key])}
                  </div>
                ))}
              </div>

              <div className="row g-2 mt-4 p-3 border-top">
                {heatMapLegend.map((leg, i) => (
                  <div
                    key={i}
                    className="col-md-3 d-flex align-items-center gap-2"
                  >
                    <div className={leg.colorClass}></div>
                    <div className="small">
                      <strong>{leg.label}</strong> {leg.subLabel}
                    </div>
                  </div>
                ))}
              </div>

              <div className="score_inter mt-3 d-flex gap-2">
                <Target size={18} className="text-primary flex-shrink-0" />
                <div className="small">
                  <strong>Strategic Heat Map Insights:</strong>{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: heatMapInsight.replace(
                        /\*\*(.*?)\*\*/g,
                        "<b>$1</b>"
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* END => Competition Heat Map Section --- */}

        {/* START => Focus Table Section --- */}
        <div ref={companyFocusesRef}>
          {companiesMp?.length > 0 ? (
            <div className="comp_map_block">
              <h5 className="mb-4 fw-bold">
                Where Should Each Company Focuses
              </h5>
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="bg-light text-secondary small">
                    <tr>
                      <th>Company</th>
                      {focusCols.map((col) => (
                        <th key={col.key}>
                          {col.icon} {col.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {companiesMp.map((co) => (
                      <tr
                        key={co.id}
                        className={
                          co.isHighlighted
                            ? "table-primary custom_highlight_table"
                            : ""
                        }
                      >
                        <td className="fw-bold font15">
                          {co.isHighlighted && (
                            <span className="badge bg-primary me-1">US</span>
                          )}
                          {co.name}
                        </td>
                        {focusCols.map((col) => (
                          <td key={col.key}>
                            {focusAreas[co.id]?.[col.key]?.map((item, i) => (
                              <span
                                key={i}
                                className={`focus-badge ${col.color} bg-opacity-10 text-dark`}
                              >
                                {item}
                              </span>
                            ))}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* END => Focus Table Section --- */}

        {/* <div ref={marketPositionNewRef}>
          <MarketPosition marketPositionData={marketPosition} />
        </div> */}

        <DetailModal
          selectedDetailModal={selectedDetailModalCi}
          setSelectedDetailModal={setSelectedDetailModalCi}
          fullData={detailedCompetitiveDataCi}
        />

        {/* START => Customer Segment Heatmap */}
        <div ref={customerSegmentHeatmapRef}>
          {customerSegmentHeatMap?.length > 0 ? (
            <div className="card border-0 mb-4">
              <div className="card-body comp_map_block">
                <h3 className="exe_summary mb-4">Customer Segment Heat Map</h3>
                <div>
                  <div className="d-flex align-items-center gap-2 text-purple fw-bold small mb-3 font13">
                    <Users size={16} /> Key Customer Segments
                  </div>
                  <div className="row g-3">
                    {customerSegmentHeatMap.map((item, idx) => {
                      const itemKey = item.dataKey || `custseg-${idx}`;
                      const isSelected = selectedHeatMapItem === itemKey;
                      return (
                        <div key={idx} className="col-md-4">
                          <div
                            className={`segment-item bg-${
                              item.color
                            } bg-opacity-10 border-start border-${
                              item.color
                            } border-2 p-3 rounded ${
                              isSelected ? "selected-segment" : ""
                            }`}
                            onClick={() =>
                              setSelectedHeatMapItem(
                                isSelected ? null : itemKey
                              )
                            }
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="flex-grow-1">
                                <div className="comp_head_new">{item.name}</div>
                                <div className="comp_subhead_new">
                                  {item.players} player
                                  {item.players > 1 ? "s" : ""} •{" "}
                                  {item.players === 4
                                    ? "Very crowded"
                                    : item.players === 3
                                    ? "Competitive"
                                    : item.players === 2
                                    ? "Moderate"
                                    : "Unique"}
                                </div>
                                {item.marketSize && (
                                  <div className="comp_head_number">
                                    {item.marketSize}
                                  </div>
                                )}
                              </div>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedDetailModalCi(itemKey);
                                }}
                                className="btn btn-sm btn-link p-0 ms-2"
                                title="Click for detailed analysis"
                              >
                                <Search size={18} className="text-primary" />
                              </button>
                            </div>
                          </div>
                          {isSelected && (
                            <div className="mt-2 ms-2 p-3 bg-white rounded border border-primary border-2 shadow-sm">
                              <div className="small fw-bold mb-2">
                                Companies serving this segment:
                              </div>
                              <div className="d-flex flex-wrap gap-1">
                                {item.companies.map((company, compIdx) => (
                                  <span
                                    style={{
                                      textWrap: "wrap",
                                      textAlign: "left",
                                    }}
                                    key={compIdx}
                                    className={`badge ${
                                      item.players === 4
                                        ? "bg-danger"
                                        : item.players === 3
                                        ? "bg-primary"
                                        : item.players === 2
                                        ? "bg-new_custom_warning"
                                        : item.players === 1
                                        ? "bg-success"
                                        : "bg-info"
                                    }`}
                                  >
                                    {company}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="row g-2 p-3 bg-light rounded mt-3">
                  {legendItems.map((leg, idx) => (
                    <div className="col-3" key={idx}>
                      <div className="d-flex align-items-center gap-2 small">
                        <div
                          className={leg.color}
                          style={{
                            width: "1rem",
                            height: "1rem",
                            borderRadius: "2px",
                          }}
                        ></div>
                        <div>
                          <div className="fw-bold">{leg.label}</div>
                          <div className="text-muted">{leg.subLabel}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="score_inter mt-2 mb-2">
                  <div className="d-flex gap-2">
                    <img
                      src="/img/bullseye.png"
                      width="16"
                      height="16"
                      alt="insight"
                    />
                    <div className="small">
                      <strong>Customer Segment Battle Map:</strong>{" "}
                      {battleMapInsight?.length
                        ? renderInsight(battleMapInsight)
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* END => Customer Segment Heatmap */}

        {/* START => Key Strengths */}
        <div ref={keyStrengthsRef}>
          {companiesCi?.length > 0 ? (
            <div className="row g-3">
              <h3 className="exe_summary">Key Strength</h3>

              {companiesCi.map((company) => (
                <div key={company.id} className="col-md-6">
                  <div
                    className={`intelligence-card bg-${company.bgColor} bg-opacity-10 border-${company.bgColor}`}
                  >
                    <h4 className="h6 fw-bold font14">{company.name}</h4>
                    <div className="mb-2">
                      <div className="small text-muted text-uppercase fw-semibold mb-1 font13">
                        Key Strength
                      </div>
                      <p className="small mb-0 font13">
                        {customerIntelligenceCi[company.id].highlight}
                      </p>
                    </div>
                    <div className="small fst-italic text-muted font13">
                      "{customerIntelligenceCi[company.id].quote}"
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </div>
        {/* END => Key Strengths */}

        {/* <div class="section-header">
          <h2 class="section-title">Customer Intelligence</h2>
          <div class="separator-line"></div>
        </div>

        <div ref={customerIntelligenceRef}>
          <CustomerIntelligence
            customerIntelligenceData={customerIntelligence}
          />
        </div> */}
      </div>

      {showScrollTop && (
        <button className="scroll-top-btn" onClick={scrollToTop}>
          {/* ↑ */}
          <FeatherIcon.ChevronUp />
        </button>
      )}
    </div>
  );
};

export default MarketPositionNew;
